import React from 'react';
import { Box, Typography } from '@mui/material';
import EventPublishedSwitch from '../../Events/widgets/EventPublishedSwitch';
import { REQUIRE_JOIN_APPROVAL_COPY } from '../../../shared/registrationSettings';

const RequireJoinApprovalField = ({
  checked = false,
  onChange,
  variant = 'event',
  SwitchComponent,
  switchSx,
  bordered = true,
  disabled = false,
  dimmed = false,
}) => {
  const copy = REQUIRE_JOIN_APPROVAL_COPY[variant] ?? REQUIRE_JOIN_APPROVAL_COPY.event;
  const SwitchControl = SwitchComponent ?? EventPublishedSwitch;
  const isDimmed = dimmed || disabled;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 3,
        py: variant === 'community' ? 1.25 : 2.5,
        ...(bordered
          ? {
              borderBottom: '1px solid',
              borderColor: 'divider',
            }
          : {}),
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: variant === 'community' ? 700 : 600,
            fontSize: variant === 'community' ? '0.875rem' : '0.9375rem',
            color: isDimmed ? 'text.disabled' : 'text.primary',
            mb: 0.5,
          }}
        >
          {copy.title}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.8125rem',
            color: isDimmed ? 'text.disabled' : 'text.secondary',
            lineHeight: 1.45,
            mb: copy.bullets?.length ? 1.25 : 0,
          }}
        >
          {copy.description}
        </Typography>
        {copy.bullets?.length ? (
          <Box
            component="ul"
            sx={{
              m: 0,
              pl: 2.25,
              color: isDimmed ? 'text.disabled' : 'text.secondary',
              fontSize: '0.8125rem',
              lineHeight: 1.55,
              '& li': {
                mb: 0.35,
              },
              '& li:last-of-type': {
                mb: 0,
              },
            }}
          >
            {copy.bullets.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </Box>
        ) : null}
      </Box>
      <Box sx={{ flexShrink: 0, pt: 0.25 }}>
        <SwitchControl
          checked={Boolean(checked)}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
          inputProps={{ 'aria-label': copy.ariaLabel }}
          {...(switchSx ? { sx: switchSx } : {})}
        />
      </Box>
    </Box>
  );
};

export default RequireJoinApprovalField;
